import { cnpStore } from "../stores/cnp.store";
import { cnpReportStore } from "../stores/cnpReport.store";

export const useCNPStore = () => cnpStore;
export const useCNPReportStore = () => cnpReportStore;
